<template>
<v-flex xs12 sm6 offset-sm3>
    <v-card class="semi-transparent-7-bg">
        <v-img :src="getImgUrl('404error')" aspect-ratio="2.75"></v-img>

        <v-card-title primary-title>
            <div>
                <h3 class="headline mb-0">404 Not Found</h3>
            </div>
        </v-card-title>

        <v-card-actions>
            <v-btn flat color="orange">Home</v-btn>
        </v-card-actions>
    </v-card>

</v-flex>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    methods: {
        getImgUrl(bank) {
            var images = require.context('@/assets/', false, /\.png$/);
            return images('./' + bank + ".png");
        }
    }
}
</script>

<style>

</style>
